import { SkillsPageSearchIcon as SearchIcon } from "@/components/icons/SkillsPageSearchIcon";

/** The search bar. It owns no state and no shortcut: the value belongs to the
 *  tab (which already had a debounce or a filter behind it), and ⌘K belongs to
 *  the command palette, which listens for it globally — the chip is a label. */
export default function SearchInput({
  value,
  placeholder,
  onChange,
}: {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="lib-search flex items-center gap-2.5 bg-bg-elevated border border-border-default rounded-10 py-2.5 px-4 transition-colors focus-within:border-gold-line-34">
      <SearchIcon className="lib-search__icon w-4 h-4 text-fg-subtle shrink-0" />
      <input
        type="text"
        className="lib-search__input flex-1 min-w-0 font-sans text-3.5 text-fg-default bg-none border-none outline-none placeholder:text-fg-subtle"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
      <kbd className="lib-search__kbd font-mono hidden can-hover:inline text-3 leading-none text-fg-subtle bg-bg-muted rounded-6 py-1 px-2 shrink-0">
        ⌘ K
      </kbd>
    </div>
  );
}
